export default {
  data() {
    return {
      /**电子处方 平台 */ 
      tabListL1Config: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          size: 'mini',
          width: '50px',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },
        {
          label: '宣教ID',
          align: 'center',
          prop: 'id',
          size: 'mini',
        },
        {
          label: '标题',
          align: 'center',
          prop: 'title',
          size: 'mini',
        },
        {
          label: '主适配病种',
          align: 'center',
          prop: 'diseaseTypeName',
          size: 'mini',
        },
		{
		  label: '适配病种',
		  align: 'center',
		  prop: 'subDiseaseTypeName',
		  size: 'mini',
      render: (h, scope) => {
        return (
          <span>
            { scope.row.subDiseaseTypeName ? scope.row.subDiseaseTypeName : '--' }
          </span>
        )
      },
		},
        {
          label: '类型',
          align: 'center',
          prop: 'missionType',
          size: 'mini',
          render: (h, scope) => {
            return (
              <span>
                {scope.row.missionType == 1
                  ? '推荐'
                  : scope.row.missionType == 2
                  ? '提醒'
                  : '辅导'}
              </span>
            )
          },
        },
        {
          label: '归属',
          align: 'center',
          prop: 'attribution',
          size: 'mini',
          render: (h, scope) => {
            return <span>{scope.row.belongTo}</span>
          },
        },
        {
          label: '创建时间',
          align: 'center',
          prop: 'createTime',
          size: 'mini',
        },
        {
          label: '创建人',
          align: 'center',
          prop:"createUserName",
          size: 'mini',
        },
        {
          label: '状态',
          align: 'center',
          prop: 'available',
          size: 'mini',
          render: (h, scope) => {
            return <span>{scope.row.available == 1 ? '启用' : '停用'}</span>
          },
        },
        {
          label: '操作',
          align: 'center',
          width: '300px',
          deleted:true,
          render: (h, scope) => {
            //是否提醒
            return h('div', {
              style: { display:"flex",flexWrap:"wrap" ,alignItems: "center"},
            },[
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { display:scope.row.deleted == false ? 'block' : 'none' },
                  on: {
                    click: () => {
                      this.seeData(scope)
                    },
                  },
                },
                '查看'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { display:scope.row.deleted == false ? 'block' : 'none' },
                  on: {
                    click: () => {
                      this.editData(scope)
                    },
                  },
                },
                '编辑'
              ),
              h(
                  'el-button',
                  {
                    props: { type: 'text', size: 'mini' },
                    style: { display:scope.row.deleted == false ? 'block' : 'none' },
                    on: {
                      click: () => {
                        this.copyData(scope)
                      },
                    },
                  },
                  '复制'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { color: scope.row.available == false ? '#ccc' : '',display:scope.row.deleted == false ? 'block' : 'none' },
                  attrs: { disabled: scope.row.available == false },
                  on: {
                    click: () => {
                      this.outService(scope)
                    },
                  },
                },
                '停用'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { color: scope.row.available == true ? '#ccc' : '' ,display:scope.row.deleted == false ? 'block' : 'none'},

                  attrs: { disabled: scope.row.available == true },
                  on: {
                    click: () => {
                      this.onService(scope)
                    },
                  },
                },
                '启用'
              ),
              h('el-button', {
                  props: { type: 'text', size: 'mini'},
                  style: {color: scope.row.available,display:scope.row.deleted == false ? 'block' : 'none' },
                  on: { click: () => {this.pushData(scope)} }
              }, '推送'),
            ])
          },
        },
      ],
       /**电子处方 机构 */
       tabListL1Config1: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          size: 'mini',
          width: '50px',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },
        {
          label: '宣教ID',
          align: 'center',
          prop: 'id',
          size: 'mini',
        },
        {
          label: '标题',
          align: 'center',
          prop: 'title',
          size: 'mini',
        },
        {
          label: '主适配病种',
          align: 'center',
          prop: 'diseaseTypeName',
          size: 'mini',
        },
		{
		  label: '适配病种',
		  align: 'center',
		  prop: 'subDiseaseTypeName',
		  size: 'mini',
      render: (h, scope) => {
        return (
          <span>
            { scope.row.subDiseaseTypeName ? scope.row.subDiseaseTypeName : '--' }
          </span>
        )
      },
		},
        {
          label: '类型',
          align: 'center',
          prop: 'missionType',
          size: 'mini',
          render: (h, scope) => {
            return (
              <span>
                {scope.row.missionType == 1
                  ? '推荐'
                  : scope.row.missionType == 2
                  ? '提醒'
                  : '辅导'}
              </span>
            )
          },
        },
        {
          label: '归属',
          align: 'center',
          prop: 'attribution',
          size: 'mini',
          render: (h, scope) => {
            return <span>{scope.row.belongTo}</span>
          },
        },
        {
          label: '创建时间',
          align: 'center',
          prop: 'createTime',
          size: 'mini',
        },
        {
          label: '创建人',
          align: 'center',
          prop:"createUserName" ,
          size: 'mini',
        },
        // {
        //   label: '状态',
        //   align: 'center',
        //   prop: 'available',
        //   size: 'mini',
        //   render: (h, scope) => {
        //     return <span>{scope.row.available == 1 ? '启用' : '停用'}</span>
        //   },
        // },
        {
          label: '操作',
          align: 'center',
          width: '300px',
          size: 'mini',
          deleted:true,
          render: (h, scope) => {
            return (
              <div>
                <el-button size="mini" type="text" onClick={() => this.seeData(scope)}>
                  查看
                </el-button>
                <el-button size="mini" type="text" onClick={() => this.quote(scope)}>
                  引用
                </el-button>
              </div>
            )
          },
        },
      ],
      toolDetailShareConfig: [
        {
          label: '序号',
          align: 'center',
          prop: 'id',
          size: 'mini',
        },
        {
          label: '分享对象',
          align: 'center',
          prop: 'name',
          size: 'mini',
        },
        {
          label: '操作',
          align: 'center',
          prop: 'remainAmount',
          size: 'mini',
          render: (h, scope) => {
            return (
              <div>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.deleteItem(scope)}
                >
                  删除
                </el-button>
              </div>
            )
          },
        },
      ],
      reainConfig: [
        // {
        //     label:'序号',
        //     align :'center',
        //     prop:"id" ,
        //     size:'mini'
        // },
        {
          label: '教程ID',
          align: 'center',
          prop: 'id',
          size: 'mini',
        },
        {
          label: '教程名称',
          align: 'center',
          prop: 'name',
          size: 'mini',
        },
        {
          label: '章节数',
          align: 'center',
          prop: 'count',
          size: 'mini',
        },
        {
          label: '病种',
          align: 'center',
          prop: 'diseaseType',
          size: 'mini',
        },
        {
          label: '归属',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            let obj = {
              1: '公域',
              2: '私域',
            }
            return <span>{obj[scope.row.scope]}</span>
          },
        },
        {
          label: '创建时间',
          align: 'center',
          size: 'mini',
          prop: 'createTime',
        },
        {
          label: '创建人',
          align: 'center',
          size: 'mini',
          prop: 'createUser',
        },
        {
          label: '状态',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            let obj = {
              1: '新建',
              2: '审核中',
              3: '已发布',
            }
            return <span>{obj[scope.row.status]}</span>
          },
        },
        {
          label: '操作',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return (
              <div>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.showItem(scope)}
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.deleteItem(scope)}
                >
                  删除
                </el-button>
                <el-button
                    size="mini"
                    type="text"
                    onClick={() => this.pushData(scope)}
                >
                  推送
                </el-button>
              </div>
            )
          },
        },
      ],
      reainChildConfig: [
        {
          label: '编号',
          align: 'center',
          prop: 'chapterNo',
          size: 'mini',
        },
        {
          label: '章节标题',
          align: 'center',
          prop: 'name',
          size: 'mini',
        },
        {
          label: '类型',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span>{scope.row.type == 1 ? '目录' : '章节内容'}</span>
          },
        },
        {
          label: '操作',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            let temp =
              scope.row.type == 2 ? (
                <div>
                  <el-button
                    size="mini"
                    type="text"
                    onClick={() => this.preview(scope)}
                  >
                    预览
                  </el-button>
                </div>
              ) : (
                ''
              )
            return temp
          },
        },
      ],
    }
  },
}
